<!-- begin #footer -->
<div id="footer" class="footer">
  <div class="row">
    <div class="col">
      <img src="/images/Bunge-K.png" class="footer-logo" />
      <span class="footer-copyright">&copy; 2025 Bunge</span>
    </div>
  </div>
</div>
<!-- end #footer -->